import { render, staticRenderFns } from "./upgrade_button.vue?vue&type=template&id=71a35f3c&scoped=true&"
import script from "./upgrade_button.vue?vue&type=script&lang=js&"
export * from "./upgrade_button.vue?vue&type=script&lang=js&"
import style0 from "./upgrade_button.vue?vue&type=style&index=0&id=71a35f3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a35f3c",
  null
  
)

export default component.exports